import React from 'react';
import PropTypes from 'prop-types';
import {SearchInput} from '@albert-io/atomic';
import './subject-menu-header.scss';

const justifyProps = [
  'center',
  'flex-end',
  'flex-start',
  'initial',
  'inherit',
  'space-around',
  'space-between'
];

const justifyContentToClassName = new Map([
  ['center', 'justify-center'],
  ['flex-end', 'justify-end'],
  ['flex-start', 'justify-start'],
  ['initial', '[justify-content:initial]'],
  ['inherit', '[justify-content:inherit]'],
  ['space-around', 'justify-around'],
  ['space-between', 'justify-between']
]);

const SubjectMenuHeader = ({searchInputProps, children, justifyContent = 'space-between'}) => {
  return (
    <div
      className={`subject-menu-header__content-wrapper ${justifyContentToClassName.get(justifyContent)}`}
    >
      {children}
      {searchInputProps ? (
        <SearchInput
          className='subject-menu-header__search'
          {...searchInputProps}
          data-testid='subject-menu-header__search-input'
        />
      ) : null}
    </div>
  );
};

SubjectMenuHeader.propTypes = {
  className: PropTypes.string,
  searchInputProps: PropTypes.object,
  backgroundColor: PropTypes.string,
  children: PropTypes.node,
  justifyContent: PropTypes.oneOf(justifyProps)
};

export default SubjectMenuHeader;
